<template>

  <v-dialog :model-value="isOpened" max-width="590" persistent @click:outside="$emit('cancel')">
    <v-card rounded="lg" class="confirmation-modal__content">
      <v-card-text class="pa-6 text-center">
        <h3>{{ title }}</h3>

        <p>{{ message }}</p>

        <slot></slot>
      </v-card-text>

      <v-card-actions class="justify-center pb-6">
        <button class="btn btn-primary" type="button" @click="$emit('confirm')">{{ confirmButtonLabel || $t('common.yes') }}</button>
        <button class="btn btn-primary" type="button" @click="$emit('cancel')">{{ cancelButtonLabel || $t('common.no') }}</button>
      </v-card-actions>
    </v-card>
  </v-dialog>

</template>

<script>

export default {

  name: 'ConfirmationModal',

  props: {

    isOpened: {
      type: Boolean,
      default: false,
      required: false,
    },

    title: {
      type: String,
      required: false,
    },

    message: {
      type: String,
      required: false,
    },
    confirmButtonLabel: {
      type: String,
      default: '',
      required: false,
    },
    cancelButtonLabel: {
      type: String,
      default: '',
      required: false,
    },

  },

  emits: ['confirm', 'cancel'],

  setup() {

    return {}
  }

}

</script>

<style lang="scss" scoped>

.confirmation-modal__content {
  font-size: 18px;
  max-height: 80vh;
  overflow: auto;

  h3 {
    font-weight: bold;
    text-transform: uppercase;
    cursor: default;
  }

  p {
    cursor: default;
    white-space: break-spaces;
  }
}

</style>
